export const contactUsLoading =  ({store})  => store.contactUsReducer.loading;

export const contactUsError =  ({store})  => store.contactUsReducer.error;

export const contactUsData =  ({store})  => store.contactUsReducer.data;